import {
    ADTA_ASSET_TYPE,
    ADTF_ASSET_TYPE,
    ASL_ASSET_TYPE,
    ASML_ASSET_TYPE,
    AUTO_LOADER_ASSET_ENABLED_STATIONS,
    AUTO_LOADER_ASSET_TYPE,
    CONFIG_TYPE,
    CONFIG_TYPE_VALUE,
    DATE_TIME_FORMAT,
    DEPRECATED,
    HEALTH_STATUS,
    INACTIVE,
    MCM,
    MCM_AMAZON,
    TCORP_AMAZON,
    TCP_PERMISSIONS,
    USER_LOGIN,
    THIN_CLIENT_ASSET_TYPE,
    TICKET,
    DEFAULT_VENDOR_ATTRIBUTES,
    SPIDER_DEPLOYMENT_SERVICE,
    STAGE,
    MQTT_ENDPOINT,
    WSS,
    AWS_REGION,
    AUTOMATION_MQTT_TOPIC_PREFIX,
    AUTOMATION_MQTT_TOPIC_SUFFIX,
    MAX_MQTT_RECONNECTION_TIME,
    ISO_STRING_TIME_START_INDEX,
    ISO_STRING_YEAR_START_INDEX,
    ISO_STRING_YEAR_END_INDEX,
    ISO_STRING_MONTH_START_INDEX,
    ISO_STRING_MONTH_END_INDEX,
    ISO_STRING_DAY_START_INDEX,
    ISO_STRING_DAY_END_INDEX,
    ISO_STRING_MINUTES_END_INDEX,
    INSTALLATION_TYPES,
    ZANCASORT_ASSET_TYPE,
    TESSERACT_ASSET_TYPE,
    AUTO_RETRIEVER_ASSET_TYPE, EMPTY_STRING, SEMI_COLON,
    MAC_ADDRESS_PREFIX,
    SUCCESS_STRING, TIMEOUT_STRING, ERROR_STRING,
    BAG_TRACKING_ALLOWED_STATIONS, ANALYTICS_CONFIG, COLON, DOT, SKYLARK_LIDAR_CONTROLLER,
    VAPR_ENABLED_STATIONS, VAPR_ASSET_TYPE
} from "./Constants";
import {getUserLoginFromParent, publishClientSideMetrics} from "../handler/ParentDataHandler";
import Alert from "@amzn/meridian/alert";
import {FormattedMessage} from "react-intl";
import React from "react";
import Text from "@amzn/meridian/text";
import {getLocalizedMessage} from "./Localization";
import {TableCell, TableRow} from "@amzn/meridian/table";
import format from "date-fns/format";
import {FEATURES, FeatureUtility} from "./FeatureUtility";
import {getEmployeeTCPRoles, getUserName} from "../resources/EmployeeResource";
import {AlchemyAnalytics} from '@amzn/alchemy-components/dist/utils/AlchemyAnalytics.es5.js';
import Icon from "@amzn/meridian/icon";
import checkCircleFilledTokens from "@amzn/meridian-tokens/base/icon/check-circle-filled";
import closeMediumTokens from "@amzn/meridian-tokens/base/icon/close-medium";
import alertTokens from "@amzn/meridian-tokens/base/icon/alert";
import infoTokens from "@amzn/meridian-tokens/base/icon/info";

function getTimeDiff(time) {
    return Date.now() - time;
}

const metricTypeEnum = {
    COUNT: "count",
    TIME: "time"
};

export const chainWalk = (func, defaultValue) => {
    try {
        const value = func();
        return isValid(value) ? value : defaultValue;
    } catch (e) {
        return defaultValue;
    }
};

export const getRandomInt = (max) => {
    return Math.floor(Math.random() * max);
}
export const sortComparator = (a, b) => {
    if(a < b) return -1;
    else if (a > b) return 1;
    else return 0;
}

export const isValid = (value) => {
    return !(value === null || value === undefined);
}

export const prettyLog = (data) => {
    console.log(JSON.stringify(data, null, 2));
}

export const areObjectsDifferent = (value, value2) => {
    return JSON.stringify(value) === JSON.stringify(value2);
}

export const deepCopyObject = (data) => {
    return JSON.parse(JSON.stringify(data));
}

const zeroPad = (num, padding) => String(num).padStart(padding || 2, '0');

export const getDownloadFileName = (configType) => {
    const date = new Date();
    const yr = zeroPad(date.getFullYear(), 4);
    const month = zeroPad(date.getMonth()+1);
    const day = zeroPad(date.getDay());
    const hr = zeroPad(date.getHours());
    const min = zeroPad(date.getMinutes());
    const sec = zeroPad(date.getSeconds());

    if(configType in CONFIG_TYPE) {
        return `${CONFIG_TYPE_VALUE[configType].replace(/ /g, '_')}_${yr}-${month}-${day}_${hr}-${min}-${sec}.csv`;
    }
    return "download.csv";
}

/**
 * Returns the sliced array based on numberOfRowsPerPage and currentPage selected
 * @param data array
 * @param currentPage
 * @param numberOfRowsPerPage
 * @param componentHandler
 * @return array
 */
export const paginationHelper = (data, currentPage, numberOfRowsPerPage, componentHandler) => {
    if(!data) return null;
    const startIndex = (currentPage-1)*numberOfRowsPerPage;
    const endIndex = currentPage*numberOfRowsPerPage;
    return data.slice(startIndex, endIndex)
      .map((instance, index) => componentHandler(instance, startIndex + index + 1, index));
}

export const createDownloadableFile = (filename, text) => {
    let element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}

export function getTimestampNow() {
    return new Date().getTime();
}

export function getTime(time) {
    if (time == null || time === '') {
        return ''
    }
    let date = new Date(time);
    let hour = date.getHours();
    let minutes = date.getMinutes();
    return ((hour < 10 ? '0' + hour : hour) + ":" + (minutes < 10 ? '0' + minutes : minutes))
}

export function getDateInIsoFormat(date) {
    return format(date, "yyyy-MM-dd")
}

/**
 * This method return the refresh interval in milliseconds for asset details from NARC
 * @returns {number}
 */
export function getAssetRefreshInterval() {
    return 5 * 60 * 1000;
}

/**
 * This method return the refresh interval in milliseconds for Manage By Exceptions tab of Lidar Controller
 * @returns {number}
 */
export function getLidarControllerManageByExceptionsRefreshInterval() {
    return 10 * 1000;
}

/**
 * This method return the refresh interval in milliseconds for status details for assets
 * @returns {number}
 */
export function getStatusRefreshInterval() {
    return 2 * 60 * 1000;
}

/**
 * This method return the refresh interval in milliseconds for status details for RFID Bag assets
 * @returns {number}
 */
export function getRFIDStatusRefreshInterval() {
    return 30 * 1000;
}
/**
 * Returns the current time in format [ MonthName dd, YYYY, HH:MM:SS GMT+__:__ ]
 * This pattern may slightly change according to current locale.
 * @param locale
 * @return string
 */
export const getCurrentFormattedTime = (locale) => {
    const currentDate = new Date();
    return new Intl.DateTimeFormat(locale, DATE_TIME_FORMAT).format(currentDate)
}

export const getFormattedTime = (locale, timeStamp) => {
    const date = new Date(parseFloat(timeStamp));
    return new Intl.DateTimeFormat(locale, DATE_TIME_FORMAT).format(date)
}

export const isTimestampWithinHours = (timestampUTC, numberOfHours) => {
    if (!timestampUTC) { return false; }
    const millisecondsInAnHour = 60 * 60 * 1000;
    return timestampUTC >= getTimestampNow() - (numberOfHours * millisecondsInAnHour);
}

export function logOperationalMetric(startTime, processName, metricName, isSuccess, isFault) {
    isSuccess ?
        publishToCSM({
            startTime: startTime,
            processName: processName,
            metricName: metricName
        }) : publishErrorToCSM({
            processName: processName,
            metricName: metricName,
            isFault: isFault
        })
}

export function publishToCSM(args) {
    let metricValue = getTimeDiff(args.startTime);
    const countMetricReq = publishClientSideMetricsRequest(args.processName, args.metricName, 1, metricTypeEnum.COUNT);
    const timeMetricReq = publishClientSideMetricsRequest(args.processName, args.metricName, metricValue, metricTypeEnum.TIME);
    publishClientSideMetrics(countMetricReq);
    publishClientSideMetrics(timeMetricReq);
}

export function publishErrorToCSM(args) {
    let countMetricReq = null
    if (args.isFault === true) {
        countMetricReq = publishClientSideMetricsRequest(args.processName, args.metricName + "Fault", 1, metricTypeEnum.COUNT);
    } else {
        countMetricReq = publishClientSideMetricsRequest(args.processName, args.metricName + "Error", 1, metricTypeEnum.COUNT);
    }
    publishClientSideMetrics(countMetricReq);
}

function publishClientSideMetricsRequest(processName, metricName, metricValue, metricType) {
    if (isOneBox()) {
        return {
            processName: processName+"_ONEBOX",
            metricName: metricName,
            metricValue: metricValue,
            metricType: metricType
        }
    } else {
        return {
            processName: processName,
            metricName: metricName,
            metricValue: metricValue,
            metricType: metricType
        }
    }
}

export const getNodeId = () => {
    const queryParams = new URLSearchParams(window.location.search);
    return queryParams.get('stationCode');
};

export const getObjectKeyForMHEValidationReport = (device, start, end) => {
    return getNodeId() + "_" + device.assetType + "_" + device.name + "_" + getMHEValidationFormatDate(start) + "_to_" +
        getMHEValidationFormatDate(end) + ".csv";
}

export const getMHEValidationFormatDate = (time) => {
    const date = new Date(time).toISOString();

    // Sample ISO String - 2024-01-04T03:03:00.000Z

    const year = date.substring(ISO_STRING_YEAR_START_INDEX, ISO_STRING_YEAR_END_INDEX);
    const month = date.substring(ISO_STRING_MONTH_START_INDEX, ISO_STRING_MONTH_END_INDEX);
    const day = date.substring(ISO_STRING_DAY_START_INDEX, ISO_STRING_DAY_END_INDEX);
    const isoTime = date.substring(ISO_STRING_TIME_START_INDEX, ISO_STRING_MINUTES_END_INDEX)

    return day + "-" + month + "-" + year + " " + isoTime;
}

export const getMacWithoutColon = (mac) => {
    return mac ? mac.replaceAll(':' ,  '') : mac ;
};

export function createRequest(processName, endPoint, requestBody) {
    return {
        processName: processName,
        endPoint: endPoint,
        request: JSON.stringify(requestBody)
    }
}

export function getAPIGatewayPostRequest(request, resourcePath) {
    return {
        resourcePath: resourcePath,
        httpMethod: "post",
        processName: "deviceManagement",
        requestBody: {
            ...request,
            [TCP_PERMISSIONS]: true,
            [USER_LOGIN]: true
        }
    }
}
export function getAPIGatewayGetRequest(resourcePath) {
    return {
        resourcePath: resourcePath,
        httpMethod: "get",
        processName: "deviceManagement",
        requestBody: {
            [TCP_PERMISSIONS]: true,
            [USER_LOGIN]: true
        }
    }
}

export function getSDSAPIGatewayPostRequest(request, resourcePath) {
    return {
        resourcePath: resourcePath,
        httpMethod: "post",
        processName: SPIDER_DEPLOYMENT_SERVICE,
        requestBody: {
            ...request,
            [TCP_PERMISSIONS]: true,
            [USER_LOGIN]: true
        }
    }
}

export function getSDSAPIGatewayGetRequest(request, resourcePath) {
    return {
        resourcePath: resourcePath,
        httpMethod: "get",
        processName: SPIDER_DEPLOYMENT_SERVICE,
        requestBody: {
            ...request,
            [TCP_PERMISSIONS]: true,
            [USER_LOGIN]: true
        }
    }
}

export function publishCountToCSM(args) {
    const countMetricReq = publishClientSideMetricsRequest(args.processName, args.metricName, 1, metricTypeEnum.COUNT);
    publishClientSideMetrics(countMetricReq);
}

export function convertTableJsonToAsset(stateValues, assetType, assetStatus, assetSubType) {
    const vendorAttributes = stateValues.vendorAttributes || DEFAULT_VENDOR_ATTRIBUTES;
    delete stateValues.vendorAttributes;
    const parentAssetLabel = stateValues.parentAssetLabel
    delete stateValues.parentAssetLabel
    return {
        "assetDetails": {
            "assetLabel": {
                "type": "MAC_ADDRESS",
                "value": stateValues.mac
            },
            "nodeId": getNodeId(),
            "assetType": assetType,
            "assetSubType": assetSubType,
            assetAttributes: stateValues,
            vendorAttributes,
            "assetStatus": assetStatus,
            "parentAssetLabel": parentAssetLabel
        }
    }
}

export function convertTableJsonToEdgeGatewayAsset(assetAttributes, assetType, assetStatus, device) {
    return {
        "assetDetails": {
            "assetLabel": {
                "type": "MAC_ADDRESS",
                "value": device.mac
            },
            "nodeId": getNodeId(),
            "assetType": assetType,
            assetAttributes,
            "assetStatus": assetStatus
        }
    }
}

export function convertTableJsonToAssetForTrafficLight(assetDetails, assetType, assetStatus) {
    return {
        "assetDetails": {
            "assetLabel": {
                "type": "MAC_ADDRESS",
                "value": assetDetails.assetAttributes.mac
            },
            "nodeId": getNodeId(),
            "assetType": assetType,
            "assetAttributes": assetDetails.assetAttributes,
            "assetStatus": assetStatus
        },
        "assetMappings": assetDetails.assetMappings
    }
}

export function convertTableJsonToRequestForNDMS(index, assetDetails) {
    return {
        "label": assetDetails.assetMappings[index].mappedResourceLabel,
        "color": assetDetails.assetMappings[index].mappingAttributes.color,
        "wave": parseInt(assetDetails.assetMappings[index].mappingAttributes.wave, 10),
        "nodeId": getNodeId()
    }
}

export const renderElementSeparator = () => {
    return (<Text> | </Text>)
}
export const getUTRRegion = () => {
    let location = window.location.href
    let region = "NA"
    if (location.includes("ui-na")) {
        region = "NA"
    } else if (location.includes("ui-eu")) {
        region = "EU"
    } else if (location.includes("ui-jp")) {
        region = "FE"
    }
    return region;
}

export const getUTRStage = () => {
    const location = window.location.href
    let stage = STAGE.PROD
    if (location.includes("ui-beta")) {
        stage = STAGE.BETA
    } else if (location.includes("ui-gamma") || location.includes("localhost")) {
        stage = STAGE.GAMMA
    }
    return stage;
}

export const AlertTesting = () => <Alert
    size="small"
    type="informational">
    <FormattedMessage id="alert.testing"
                      defaultMessage="No Testing Setup present."/>
</Alert>

export const AlertConfiguration = () => <Alert
    size="small"
    type="informational">
    <FormattedMessage id="alert.configuration"
                      defaultMessage="No Configuration Setup present."/>
</Alert>

export const assetTypeToConfigTypeDict = {
    typeADTA: ADTA_ASSET_TYPE,
    typeADTF: ADTF_ASSET_TYPE,
    typeASL: ASL_ASSET_TYPE,
    typeZANCASORT: ZANCASORT_ASSET_TYPE,
    typeTESSERACT: TESSERACT_ASSET_TYPE,
    typeAUTO_RETRIEVER: AUTO_RETRIEVER_ASSET_TYPE,
    typeAUTO_LOADER: AUTO_LOADER_ASSET_TYPE,
    typeTC: THIN_CLIENT_ASSET_TYPE,
    typeASML: ASML_ASSET_TYPE,
    typeVAPR: VAPR_ASSET_TYPE,
};

export const getCurrentDate = () => {
    return new Date().getTime();
}

/**
 * Convert an epoch timestamp (milliseconds) string to a human-readable local date-time string.
 * Expected input format: epoch millis as string, e.g. "1771402357714"
 * Output format adapts to user's browser locale, e.g. "Mar 10, 17:31 PST"
 * Returns empty string if the input is falsy or invalid.
 *
 * @param {string} epochMillis - Epoch timestamp in milliseconds as a string
 * @returns {string} Formatted date-time string or empty string
 */
export const formatTimestampToReadable = (epochMillis) => {
    if (!epochMillis) return "";
    const date = new Date(Number(epochMillis));
    if (isNaN(date.getTime())) return "";
    return date.toLocaleString(undefined, {
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZoneName: "short"
    });
}

export function formatDate(inputDate) {
    // Convert yyyy-MM-dd to MM/dd/yyyy
    const date = new Date(inputDate);
    if (!isNaN(date.getTime())) {
        // Months use 0 index.
        return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
    }
}

// convert mac address ab:ab:ab:ab:ab to thingName tc-ababababab-DBE2_Core
export function macToThingName(mac) {
    return "tc-" + mac.replace(/:/g, '') + "-" + getNodeId() + "_Core";
}

// convert thingName tc-ababababab-DBE2_Core format to mac address ab:ab:ab:ab:ab
export function thingNameToMac(thingName) {
    return thingName.split("-")[1].replace(/(..)/g, '$1:').slice(0, -1);
}

// convert mac address ab:ab:ab:ab:ab to CoreDeviceName spider-ababababab-dbe2
export function convertMacToCoreDeviceName(mac) {
    return "spider-" + mac.replace(/:/g, '') + "-" + getNodeId().toLowerCase();
}

// null and undefined check: return true if not null/undefined and false otherwise
export function checkNullAndUndefinedAttribute(attributeName) {
    return !(!attributeName || Object.keys(attributeName).length === 0 || Object.getPrototypeOf(attributeName) === Object.prototype)
}

// converts ethernet IP address to VLAN number
export function getVlan(ethernetIp) {
    if (ethernetIp) {
        if (ethernetIp.startsWith('192')) {
            // AEN
            if (ethernetIp.startsWith('192.168.85')) {
                return '740';
            } else if (ethernetIp.startsWith('192.168.10.')) {
                return '702';
            }
        } else if (ethernetIp.startsWith('10.')) {
            // N19
            // Reference: https://w.amazon.com/bin/view/OTIE/N19/Vlans/#IP_Allocation_for_Pod_Based_Network_Stacks_.28golfballv2.2C_tennisball.2C_etc..29
            const octets = ethernetIp.split('.');

            if ((octets[1] === '1' && Number(octets[2]) >= 64 && Number(octets[2]) < 96)
                || (['88', '89', '90', '91'].includes(octets[2]))) {
                return '740';
            } else if ((octets[1] === '32')
                || (octets[1] === '129' && Number(octets[2]) >= 0 && Number(octets[2]) < 128)
                || (Number(octets[1]) - 1 % 16 === 0 && Number(octets[2]) >= 0 && Number(octets[2]) < 32)) {

                // 10.129.0/19
                // 10.Nx16+1.0/19
                // 10.129.0/17
                // 10.32.0/16
                return '702';
            }
        }
    }
    return 'Unknown';
}

export function getLocationFromAssetMappings(assetMappings) {
    let aisleLabels = [];
    assetMappings.forEach((mapping) => {
        if(mapping.mappedResourceLabel) {
            aisleLabels.push(mapping.mappedResourceLabel);
        }
    });
    aisleLabels = sortAlphaNumeric(aisleLabels);
    return aisleLabels[0] + " to " + aisleLabels[aisleLabels.length-1];
}

export function getAssetLabelFromMac(mac) {
    return {
        type: "MAC_ADDRESS",
        value: mac
    }
}

export const getSorterConfigLocationStringForm = (locations) => {
    // Handling empty strings because of wrong entries in some db records.
    // TODO: remove this handling later.
    if(Array.isArray(locations)) return locations.join(';');
    return locations;
}

export const getAutoLoaderConfigLocationStringForm = (locations) => {
    // Handling empty strings because of wrong entries in some db records.
    // TODO: remove this handling later.
    if(Array.isArray(locations)) return locations.join(';');
    return locations;
}

export const getStowConfigScannableList = (trackingId, shippingId) => {
    return [trackingId, shippingId].filter(Boolean)
}

export const getShippingIdFromScannableList = (scannables, trackingId) => {
    const filteredList = scannables.filter((item) => item !== trackingId)
    return filteredList.length > 0 ? filteredList[0] : "";
}

export const getTestConfigKey = (scannables) => {
    return scannables.sort().join(';')
}

export const getPickStationsValue = (pickStationsList) => {
    return pickStationsList ? pickStationsList.sort().join(SEMI_COLON) : EMPTY_STRING;
}

export const getSorterConfigKey = (bayId, type) => {
    return bayId + "_" + type;
}

export const getAutoLoaderConfigKey = (destination, type) => {
    return destination + "_" + type;
}

export const getSortedListWithOther = (unsortedList) => {
    const sortedList = unsortedList.filter(item => item !== "other").sort();
    sortedList.push("other");
    return sortedList;
}

export const getADTFSorterConfigKey = (sorterId, destinationId, type) => {
    return sorterId + "_" + destinationId + "_" + type;
}

export function compressSorterConfig(sorterConfig) {
    const sorterConfigMap = {}
    sorterConfig.forEach((config) => {
        const key = getSorterConfigKey(config.bayId, config.installation.type);
        if (key in sorterConfigMap) {
            sorterConfigMap[key].installation.locations.push(...config.installation.locations);
        } else {
            sorterConfigMap[key] = config;
        }
    })
    return Object.values(sorterConfigMap);
}

export function compressAutoLoaderConfig(autoLoaderConfig) {
    const autoLoaderConfigMap = {}
    autoLoaderConfig.forEach((config) => {
        const key = getAutoLoaderConfigKey(config.destination, config.installation.type);
        if (key in autoLoaderConfigMap) {
            autoLoaderConfigMap[key].installation.locations.push(...config.installation.locations);
        } else {
            autoLoaderConfigMap[key] = config;
        }
    })
    return Object.values(autoLoaderConfigMap);
}

export function flattenADTFSorterConfig(sorterConfigMap) {
    if(Array.isArray(sorterConfigMap)) return sorterConfigMap;
    const parsedSorterConfig = [];
    for(let sorterId in sorterConfigMap) {
        let sorterConfig = sorterConfigMap[sorterId];
        sorterConfig.forEach((config) => {
            parsedSorterConfig.push({
                ...config,
                sorterId
            });
        })
    }
    return parsedSorterConfig;
}

export function convertADTFSorterConfigIntoDBFormat(sorterConfig) {
    const parsedSorterConfigMap = {};
    for(let config of sorterConfig) {
        if(config.sorterId in parsedSorterConfigMap) {
            parsedSorterConfigMap[config.sorterId].push({
                destinationId: config.destinationId,
                installation: config.installation
            });
        } else {
            parsedSorterConfigMap[config.sorterId] = [{
                destinationId: config.destinationId,
                installation: config.installation
            }];
        }
    }
    return parsedSorterConfigMap;
}

export function sortAlphaNumeric(keys) {
    var sortedKeys = keys.sort(function(a, b) {
        return a.localeCompare(b, undefined, {
            numeric: true,
            sensitivity: 'base'
        });
    });
    return sortedKeys;
}

export function checkInactiveOrDeprecatedAsset(assetStatus) {
    return assetStatus === DEPRECATED || assetStatus === INACTIVE;
}

export function checkHealthStatusForDeletion(healthStatus) {
    return healthStatus === HEALTH_STATUS.DISCONNECTED.string || healthStatus === HEALTH_STATUS.LOADING_FAILED.string
}

export const versionString = (intl, timestamp, alias) => {
    const time = (getLocalizedMessage({intl,stringId:"alert.createdOn"})) + getFormattedTime(intl.locale, timestamp);
    const aliasName = alias ? (getLocalizedMessage({intl,stringId:"alert.byUser"}) + alias) : "";
    return time + aliasName;
}


export async function getAliasFromParent() {
    let response = await getUserLoginFromParent();
    const name =  response.name.replace(/['"]/g, '');
    return name;
}

export function checkValidLink(linkTab, link){
    if(linkTab === MCM)
        return link.match(MCM_AMAZON);
    else if(linkTab === TICKET)
        return link.match(TCORP_AMAZON);
    else
        return (link.length > 0);
}

export async function setAliasToRequest(request){
    let alias = await getAliasFromParent();
    request.assetDetails.alias = alias;
    return;
}

export async function setAliasToTriggerMHEValidationRequest(request){
    let alias = await getAliasFromParent();
    request.triggerData.validationAttributes["alias"] = alias;
    return;
}

/**
 * Checks existence of one-box string in the url
 * @return {boolean}
 */
export function isOneBox() {
    let location = window.location.href
    return location && location.includes("onebox");
}

/**
 * Checks if status is 5XX or not
 * @return {boolean}
 */
export function isResponseCode5xx(input) {
    if (input >= 500 && input <= 599){
        return true;
    }
    return false;
}

export function getMQTTClientConfig() {
    const region = getUTRRegion()
    const stage = getUTRStage()

    return {
        host: MQTT_ENDPOINT[stage][region],
        protocol: WSS,
        region: AWS_REGION[region],
        maximumReconnectTimeMs: MAX_MQTT_RECONNECTION_TIME
    };
}

export function getAutomationMQTTTopic() {
    return AUTOMATION_MQTT_TOPIC_PREFIX + getNodeId() + AUTOMATION_MQTT_TOPIC_SUFFIX;
}

export function renderMHELogsTableHeader(intl) {
    return (
        <TableRow highlightOnHover={false}>
            <TableCell width='10%'>{getHeaderText(intl, 'mhelog.datetime')}</TableCell>
            <TableCell width='10%'>{getHeaderText(intl, 'mhelog.protocol')}</TableCell>
            <TableCell width='5%'>{getHeaderText(intl, 'mhelog.devicetype')}</TableCell>
            <TableCell width='8%'>{getHeaderText(intl, 'mhelog.devicename')}</TableCell>
            <TableCell width='12%'>{getHeaderText(intl, 'mhelog.macip')}</TableCell>
            <TableCell width='10%'>{getHeaderText(intl, 'mhelog.eventtype')}</TableCell>
            <TableCell width='10%'>{getHeaderText(intl, 'mhelog.message')}</TableCell>
            <TableCell width='35%'>{getHeaderText(intl, 'mhelog.payload')}</TableCell>
        </TableRow>
    )
}

export function renderMHELogsTableRow(data, type) {
    return (
        <TableRow highlightOnHover={true}>
            <TableCell width='10%'>{getBodyText(data.timestamp)}</TableCell>
            <TableCell width='10%'>{getBodyText(data.component)}</TableCell>
            <TableCell width='5%'>{getBodyText(type)}</TableCell>
            <TableCell width='8%'>{getBodyText(data.name)}</TableCell>
            <TableCell width='12%'>{getBoldBodyText(data.mac)}{getBodyText(data.ip)}</TableCell>
            <TableCell width='10%'>{getBodyText(data.eventType)}</TableCell>
            <TableCell width='10%'>{getBodyText(data.message)}</TableCell>
            <TableCell width='35%'>{getBodyText(JSON.stringify(data.payload))}</TableCell>
        </TableRow>
    )
}

export function getHeaderText(intl, stringId) {
    return <Text breakWord={true} truncate={false} type={"h100"}>{getLocalizedMessage({intl, stringId: stringId})}</Text>
}

export function getBodyText(data) {
    return <Text breakWord={true} truncate={false}>{data}</Text>
}

export function getBoldBodyText(data) {
    return <Text breakWord={true} truncate={false} type={"h100"}>{data}</Text>
}

export function generateFileName(prefix) {
    const date = new Date();
    const yr = zeroPad(date.getFullYear(), 4);
    const month = zeroPad(date.getMonth() + 1);
    const day = zeroPad(date.getDay());
    const hr = zeroPad(date.getHours());
    const min = zeroPad(date.getMinutes());
    const sec = zeroPad(date.getSeconds());

    return `${prefix}_${yr}-${month}-${day}_${hr}-${min}-${sec}.csv`;
}

export function getFormattedTimestamp(timestamp) {
    const date = new Date(timestamp);
    const yr = zeroPad(date.getUTCFullYear(), 4);
    const month = zeroPad(date.getUTCMonth() + 1);
    const day = zeroPad(date.getUTCDate());
    const hr = zeroPad(date.getUTCHours());
    const min = zeroPad(date.getUTCMinutes());
    const sec = zeroPad(date.getUTCSeconds());
    const milliSec = date.getUTCMilliseconds();

    return `${day}/${month}/${yr}, ${hr}:${min}:${sec}.${milliSec}`;
}

export function getInstallationTypes (assetType = null) {
    if (AUTO_LOADER_ASSET_TYPE === assetType){
        return([INSTALLATION_TYPES.SIDELINE,INSTALLATION_TYPES.AISLE])}

    let installationTypes = [];

    if (FeatureUtility.getFeatureStatus(FEATURES.IS_SSD_2_X_ENABLED)) {
        installationTypes = [
            INSTALLATION_TYPES.JACKPOT,
            INSTALLATION_TYPES.OV,
            INSTALLATION_TYPES.BULKY,
            INSTALLATION_TYPES.Zone,
            INSTALLATION_TYPES.PROBLEM_SOLVE
        ];
    } else {
        installationTypes =  [
            INSTALLATION_TYPES.FLOOR,
            INSTALLATION_TYPES.AISLE,
            INSTALLATION_TYPES.JACKPOT,
            INSTALLATION_TYPES.RECIRCULATION,
            INSTALLATION_TYPES.OV,
            INSTALLATION_TYPES.BULKY,
            INSTALLATION_TYPES.CLUSTER,
            INSTALLATION_TYPES.COLUMN,
            INSTALLATION_TYPES.FRAGILE
        ];
    }

    // Adding sort zone installation for ADTA_HAMPER_ZONING
    if (FeatureUtility.getFeatureStatus(FEATURES.IS_ADTA_HAMPER_ZONING_ENABLED)
        && !installationTypes.includes(INSTALLATION_TYPES.SORT_ZONE)) {
        installationTypes.push(INSTALLATION_TYPES.SORT_ZONE);
    }

    // Adding problem solve installation for PS_ON_GRID_SORTATION
    if (FeatureUtility.getFeatureStatus(FEATURES.IS_PROBLEM_SOLVE_ON_GRID_SORTATION_FLOW_ENABLED)
        && !installationTypes.includes(INSTALLATION_TYPES.PROBLEM_SOLVE)) {
        installationTypes.push(INSTALLATION_TYPES.PROBLEM_SOLVE);
    }

    // Adding Bin installation for programs diverting packages to bins
    // Like Project Rush
    if (FeatureUtility.getFeatureStatus(FEATURES.IS_BIN_INSTALLATION_TYPE_ENABLED)
        && !installationTypes.includes(INSTALLATION_TYPES.BIN)) {
        installationTypes.push(INSTALLATION_TYPES.BIN);
    }

    return installationTypes;
}

export function getInstallationTypeValues (assetType = null) {
    return getInstallationTypes(assetType).map((installation) => {
        return installation.value;
    });
}

export function getOrdinal(n) {
    let ord = 'th';
    if (n % 10 === 1 && n % 100 !== 11) {
        ord = 'st';
    } else if (n % 10 === 2 && n % 100 !== 12) {
        ord = 'nd';
    } else if (n % 10 === 3 && n % 100 !== 13) {
        ord = 'rd';
    }
    return ord;
}

export function getChildDeviceBySubType(parentMacAddress, childAssetList, assetSubType) {
    const model = {
        childAsset: null,
    }
    childAssetList.forEach((childAsset) => {
        if(childAsset.parentAssetLabel === MAC_ADDRESS_PREFIX +  parentMacAddress && childAsset.assetSubType === assetSubType) {
            model.childAsset = childAsset;
        }
    });
    return model;
}

/**
 * Extracts device type and tab name from the current path
 * @param pathname - Current route path (format: /devicemanagement/[device]/[tab])
 * @returns {{deviceType: string, tabName: string}}
 */
export const getDeviceAndTabInfo = (pathname) => {
    const pathParts = pathname.split('/');
    const deviceName = pathParts[2];
    if (!deviceName) {  //no device is selected
        return {
            deviceType: "None",
            tabName: "None"
        }
    }
    const tabName = pathParts[3] || 'overview';

    return {
        deviceType: deviceName.toUpperCase(),
        tabName: tabName
    };
};

/**
 * Publish Alchemy Analytics of current tab to Pendo.
 * @param {string} pathname - Current route path (format: /devicemanagement/[device]/[tab])
 */
export const publishAlchemyAnalytics = async (pathname) => {
    try {
        const visitorId = (await getUserName()).split('@')[0];
        const employeeTCPRoles = await getEmployeeTCPRoles();
        const deviceInfo = getDeviceAndTabInfo(pathname);

        const visitorData = {
            id: visitorId,
            stationCode: getNodeId(),
            stage: getUTRStage(),
            region: getUTRRegion(),
            scc_roles: employeeTCPRoles,
            current_device_type: deviceInfo.deviceType,
            current_tab_name: deviceInfo.tabName,
            current_tab_entry_time: Date.now()
        };

        if (!window.analytics) {
            window.analytics = new AlchemyAnalytics({
                apikey: ANALYTICS_CONFIG.PENDO_AK,
                account: { id: ANALYTICS_CONFIG.ACCOUNT_ID },
                visitor: visitorData
            });
        } else {
            window.analytics.updateOptions({visitor: visitorData});
        }
    } catch (err) {
        const error = err instanceof Error ? err : new Error('Failed to initialize analytics');
        console.warn('Failed to initialize Pendo', error);
    }
};

export function getFloorsWithMultipleAssignedSlides (floorSorterConfig, floorsForSlide) {
    const floors = new Map();

    floorSorterConfig.forEach(config => {
        config.installation.locations.forEach(location => {
            if (!floors.has(location)) {
                floors.set(location, false);
            }
        });
    });

    const floorsWithMultipleAssignedSlides = [];
    floorsForSlide.forEach(floorForSlide => {
        if (floors.has(floorForSlide)) {
            if (floors.get(floorForSlide)) {
                floorsWithMultipleAssignedSlides.push(floorForSlide);
            } else {
                floors.set(floorForSlide, true);
            }
        }
    });
    return floorsWithMultipleAssignedSlides;
}

export function getSorterConfigForInstallationType(sorterConfig, installationType) {
    return sorterConfig.filter(config => {
        return config.installation && config.installation.type === installationType.value;
    });
}

export function getFloorsForSlide (sorterConfig) {
    let locations = [];

    sorterConfig.forEach(config => {
        config.installation.locations.forEach(locationString => {
            const individualLocations = locationString.split(SEMI_COLON);

            individualLocations.forEach(item => {
                if (item.includes(COLON)) {
                    const [start, end] = item.split(COLON);

                    const prefix = start.substring(0, start.indexOf('L') + 1);
                    const suffix = start.substring(start.lastIndexOf(DOT));

                    const startNum = parseInt(start.substring(start.indexOf('L') + 1, start.lastIndexOf(DOT)), 10);
                    const endNum = parseInt(end.substring(end.indexOf('L') + 1, end.lastIndexOf(DOT)), 10);

                    for (let index = startNum; index <= endNum; index++) {
                        const paddedNum = index < 10 ? `0${index}` : `${index}`;
                        locations.push(`${prefix}${paddedNum}${suffix}`);
                    }
                } else {
                    locations.push(item);
                }
            });
        });
    });
    return locations;
}

// Helper function to render status with appropriate Meridian icon
export const renderStatusWithIcon = (status, message, color) => {
    const getIconTokens = (status) => {
        switch (status) {
            case SUCCESS_STRING: return checkCircleFilledTokens;
            case ERROR_STRING: return closeMediumTokens;
            case TIMEOUT_STRING: return alertTokens;
            default: return infoTokens;
        }
    };

    // Define link colors for different backgrounds
    const getLinkStyle = (status) => {
        switch (status) {
            case ERROR_STRING: 
                return { color: '#FFFFFF', textDecoration: 'underline', fontWeight: 'bold' }; // White on red background
            case TIMEOUT_STRING: 
                return { color: '#000000', textDecoration: 'underline', fontWeight: 'bold' }; // Black on amber background
            default: 
                return { color: '#1976D2', textDecoration: 'underline' }; // Blue for other backgrounds
        }
    };

    const linkStyle = getLinkStyle(status);

    return (
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <Icon tokens={getIconTokens(status)} size="small" style={{marginRight: '12px'}} />
            <div 
                style={{color: color}} 
                dangerouslySetInnerHTML={{ 
                    __html: message.replace(
                        /<a /g, 
                        `<a style="color: ${linkStyle.color}; text-decoration: ${linkStyle.textDecoration}; font-weight: ${linkStyle.fontWeight || 'normal'};" `
                    ) 
                }} 
            />
        </div>
    );
};

export function isSensorLevelConfigEnabledForLidarController (lidarDeviceInfo) {
    return lidarDeviceInfo && lidarDeviceInfo.lidarControllerType === SKYLARK_LIDAR_CONTROLLER &&
        lidarDeviceInfo.numberOfNonOVLidarSensors > 0
}

export const IS_BAG_TRACKING_ALLOWED = BAG_TRACKING_ALLOWED_STATIONS.includes(getNodeId());
export const IS_AUTO_LOADER_ENABLED  = AUTO_LOADER_ASSET_ENABLED_STATIONS.includes(getNodeId());
export const IS_VAPR_ENABLED = VAPR_ENABLED_STATIONS.includes(getNodeId());


// WEBPACK FOOTER //
// ./src/components/util/Util.js